import {
  ModalBody,
  ModalFooter,
  ModalProps
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import Modal from "components/Modal/Modal";
import React from "react";
import { ApplyButton } from "../ApplyButton/ApplyButton";
import * as styles from "./ModalDepartureDate.module.scss";
import { DepartureDateFilterList } from "../Filters/DepartureDateFilter";
import { FirstLastDepartureCruiseDates } from "types/graphql-types";

export type ModalDepartureDateProps = {
  isVisible?: boolean;
  firstLastDepartureCruiseDates: FirstLastDepartureCruiseDates;
};

type Props = ModalDepartureDateProps &
  Omit<ModalProps, "modal"> & {
    modal: Omit<ModalProps["modal"], "isOpen">;
  };

const ModalDepartureDate: React.FC<Props> = ({
  modal,
  dataContentName,
  isVisible = false,
  firstLastDepartureCruiseDates,
  title
}) => {
  return (
    <Modal
      title={title}
      modal={{
        ...modal,
        isOpen: true, // force modal to be always mounted. If unmounted the filters are resetted
        portalClassName: clsx({ [styles.hideModal]: !isVisible })
      }}
      size="fullscreen"
      dataContentName={dataContentName}
    >
      <ModalBody variant="wide" removeScroll={isVisible}>
        <DepartureDateFilterList
          id="modal-dep-date"
          firstLastDepartureCruiseDates={firstLastDepartureCruiseDates}
        />
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <ApplyButton onClick={modal.onRequestClose} />
      </ModalFooter>
    </Modal>
  );
};

export default ModalDepartureDate;
